import React from 'react';
import {ExternalForwardLink} from "../common/ForwardLink";
import Urls from "../../Urls";
import { generateUrlWithRefTag, PILL_PACK_REF_TAGS } from "../csa/utils";

interface SeeFuturePillPackDeliveriesCardProps {
    label: string;
}
class SeeFuturePillPackDeliveriesCard extends React.Component<SeeFuturePillPackDeliveriesCardProps, {}> {

    render() {
        return (
            <pui-product-card noshadow="true" spacingBottom="med-small" paddingTop="med-small" paddingLeft="mini"
                                 paddingRight="med-small">
                <ExternalForwardLink
                  url={generateUrlWithRefTag(Urls.DELIVERY_SCHEDULE_URL,
                    PILL_PACK_REF_TAGS.SEE_FUTURE_DELIVERY_TO_MANAGE_FUTURE_DELIVERIES)}
                  csaId={'pillpack-future-delivery-schedule'}>
                <pui-stack
                    direction="horizontal"
                    secondaryAxisArrangement={'center'}
                    mainAxisArrangement="start">
                    <pui-stack-item>
                        <pui-icon imgClass='pillpack-icon' style={{height: '48px', width: '48px'}}/>
                    </pui-stack-item>
                    <pui-stack spacingLeft={'medium'}>
                        <pui-heading input={this.props.label} headingLevel="3" textSize="small"/>
                    </pui-stack>
                </pui-stack>
            </ExternalForwardLink></pui-product-card>
        )
    }
}

export default SeeFuturePillPackDeliveriesCard;